import { render, staticRenderFns } from "./ModalTriagem.vue?vue&type=template&id=019c261c"
import script from "./ModalTriagem.vue?vue&type=script&lang=ts"
export * from "./ModalTriagem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports